import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
import WToolTip from "@/components/tooltip/w-toolTip.vue";
let DualChoiceToggle = class DualChoiceToggle extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "firstOption", void 0);
    _defineProperty(this, "secondOption", void 0);
    _defineProperty(this, "firstOptionTooltip", void 0);
    _defineProperty(this, "secondOptionTooltip", void 0);
    _defineProperty(this, "tooltipPosition", void 0);
    _defineProperty(this, "firstOptionIcon", void 0);
    _defineProperty(this, "secondOptionIcon", void 0);
    _defineProperty(this, "chooseFirstOptionByDefault", void 0);
    _defineProperty(this, "isFirstOptionChoosed", false);
  }
  mounted() {
    this.isFirstOptionChoosed = this.chooseFirstOptionByDefault;
  }
  setFirstOptionState(value) {
    this.isFirstOptionChoosed = value;
    return value;
  }
};
__decorate([Prop({
  default: 'First option'
})], DualChoiceToggle.prototype, "firstOption", void 0);
__decorate([Prop({
  default: 'Second option'
})], DualChoiceToggle.prototype, "secondOption", void 0);
__decorate([Prop({
  default: ''
})], DualChoiceToggle.prototype, "firstOptionTooltip", void 0);
__decorate([Prop({
  default: ''
})], DualChoiceToggle.prototype, "secondOptionTooltip", void 0);
__decorate([Prop({
  default: 'top'
})], DualChoiceToggle.prototype, "tooltipPosition", void 0);
__decorate([Prop({
  default: ''
})], DualChoiceToggle.prototype, "firstOptionIcon", void 0);
__decorate([Prop({
  default: ''
})], DualChoiceToggle.prototype, "secondOptionIcon", void 0);
__decorate([Prop({
  default: false
})], DualChoiceToggle.prototype, "chooseFirstOptionByDefault", void 0);
__decorate([Emit('choiceUpdate')], DualChoiceToggle.prototype, "setFirstOptionState", null);
DualChoiceToggle = __decorate([Component({
  components: {
    WToolTip
  }
})], DualChoiceToggle);
export default DualChoiceToggle;